module.exports = __webpack_public_path__ + "img/title@2x.520e0946.png";